import React from 'react'

export const data = [
  {
    id: 1,
    color: 'grey',
    title: null,
    description: null,
    image: 'newspaper9.jpg',
    html: null,
    link: null
  },
  {
    id: 2,
    color: 'grey',
    title: null,
    description: null,
    image: 'newspaper4.jpg',
    html: null,
    link: null
  },
  {
    id: 3,
    color: 'yellow',
    title: 'Une mémoire qui repose en paix',
    description: 'Philippe Amez-Droz',
    image: 'expert-1.jpg',
    html: null,
    link: '594197901383'
  },
  {
    id: 4,
    color: 'grey',
    title: null,
    description: null,
    image: 'newspaper2.jpg',
    html: null,
    link: null
  },
  {
    id: 5,
    color: 'grey',
    title: 'À bicyclette vers la fin d’un siècle',
    description: "Journal de l'époque",
    image: 'newspaper3.jpg',
    html: (
      <>
        <h4>À bicyclette vers la fin d’un siècle</h4>
        <p>
          Les annonces sont légion dans les éditions de «La Tribune de Genève»
          de la fin du XIXe siècle et du début du XXe. Le fragment ci-dessous
          d’une page, parue le 27 septembre 1881, témoigne de la variété de ce
          qui a toujours été le nerf de la guerre du journal.
        </p>
        <p>
          La publicité pour une bicyclette à grande roue caractéristique de ces
          années-là plonge le lecteur au temps des débuts de la «petite reine».
          «Se méfier des imitations», indique l’unique concessionnaire pour la
          Suisse de ces machines de fabrication anglaise. Son annonce
          spectaculaire voisine avec des publicités pour un roman pour dames, du
          papier d’emballage, les services d’un dentiste sans douleur et le
          savoir-faire d’une blanchisseuse de plumes. «La Tribune» a deux ans et
          le siècle court, ou plutôt roule déjà à sa fin.
        </p>
        <img src={require('../images/inline-velo.jpg')} />
      </>
    ),
    link: null
  },
  {
    id: 6,
    color: 'yellow',
    title: 'Martine Brunschwig Graf',
    description:
      "Présidente de l'Association pour la numérisation des journaux patrimoniaux genevois",
    image: 'martine.jpg',
    html: (
      <>
        <h4>Martine Brunschwig Graf est aux anges</h4>
        <p>
          «Je suis absolument ravie qu’une première tranche de numéros anciens
          de la «Tribune» soit enfin disponible en ligne, se réjouit Martine
          Brunschwig Graf. Avant même que je sois sollicitée pour présider
          l’Association pour la numérisation des journaux patrimoniaux genevois
          (ANJG), j’étais déjà convaincue de la nécessité de numériser les
          collections de la presse suisse. La mise en ligne en 2008 de
          l’intégralité du «Journal de Genève», de la «Gazette de Lausanne» et
          du «Nouveau Quotidien» m’avait enchantée. J’ai réalisé quelle mine de
          renseignements cela constitue, toute la vie du monde y est,
          l’évolution de la société, l’allure et le contenu des petites
          annonces, le prix des choses, comment on racontait le monde à
          l’époque, c’est passionnant autant pour le citoyen lambda curieux du
          passé que pour le chercheur plus pointu, ou même pour les entreprises
          de la place, qui y trouvent la trace de leurs débuts.»
        </p>
        <div className='quote portrait'>
          «Je suis absolument ravie qu’une première tranche de numéros anciens
          de la «Tribune» soit enfin disponible en ligne»
        </div>
        <p>
          L’ancienne députée, conseillère d’État et conseillère nationale
          genevoise, se passionne pour la généalogie. «La Liberté» en ligne lui
          a permis de faire des découvertes intéressantes, car sa famille est
          fribourgeoise, et avant cela alsacienne. «Nous prévoyons de pouvoir
          lancer en 2021 la lecture en ligne d’une première tranche de numéros
          du «Courrier» et de «La Suisse» jusqu’en 1920, assure la présidente de
          l’ANJG. L’ensemble du projet devrait être achevé en 2024. La récolte
          de fonds dont s’occupe notre association avance bien, j’ai bon espoir.
          Le moment venu, nous ferons figurer les noms des donateurs, s’ils le
          souhaitent, sur le portail de consultation et sur le site actuellement
          en construction de l’association.» Le coût estimé du projet est de
          1’500’000 fr.
        </p>
      </>
    ),
    link: null
  },
  {
    id: 7,
    color: 'grey',
    title: null,
    description: null,
    image: 'newspaper5.jpg',
    html: null,
    link: null
  },
  {
    id: 8,
    color: 'grey',
    title: 'Morte pendant la mise en page',
    description: "Journal de l'époque",
    image: 'assassinat.jpg',
    html: (
      <>
        <h4>Morte pendant la mise en page</h4>
        <p>
          Les éditions de «La Tribune» se succèdent pendant une même journée,
          car le journal est mince et souvent modifié.
        </p>
        <p>
          Le 10 septembre 1898, l’article annonçant l’attentat commis le jour
          même contre l’impératrice d’Autriche Elisabeth, alias Sissi, est
          composé avant que la mort de la souveraine ait été annoncée. «Elle n’a
          pas encore repris connaissance, et l’on ne peut se rendre compte de la
          gravité de la blessure qu’elle a reçue. Quant à l’auteur de
          l’attentat, on croit qu’on a affaire à un anarchiste, ou à un
          irrédentiste. Il a été immédiatement mis en lieu sûr.» La colonne
          s’arrêtait là quand une nouvelle de dernière minute vient la
          compléter: «Au dernier moment, nous apprenons que l’impératrice est
          morte sans avoir repris connaissance.»
        </p>
        <img src={require('../images/inline-assassinat.jpg')} />
      </>
    ),
    link: null
  },
  {
    id: 9,
    color: 'yellow',
    title: 'Une fête pour l’ancêtre du CEVA',
    description: "Parole d'expert",
    image: 'expert-2.jpg',
    html: null,
    link: '592935159204'
  },
  {
    id: 10,
    color: 'grey',
    title: 'Nos vœux sont dans le journal',
    description: "Journal de l'époque",
    image: 'voeux.jpg',
    html: (
      <>
        <h4>Nos vœux sont dans le journal</h4>
        <p>
          Voici 1900, le cap est passé et les vœux sont de rigueur. Dans les
          éditions des 31 décembre 1899, 1er et 2 janvier 1900 de «La Tribune de
          Genève», un espace est réservé à «la première liste des personnes qui,
          ayant renoncé à l’envoi de cartes de visite, expriment néanmoins à
          leurs amis les meilleurs vœux de nouvelle année».
        </p>
        <p>
          C’est comme aujourd’hui les remerciements après décès publiés dans le
          journal, sauf que la liste des personnes disant «bonne année» à la
          ronde est fort longue. On y trouve un résumé de la société genevoise
          de 1900, commerçants, banquiers, avocats, pasteurs, le grand rabbin
          Wertheimer, le professeur Théodore Flournoy, qui a sa rue aux
          Eaux-Vives, des noms disparus, d’autres portés encore par les
          descendants de ces lanceurs de vœux.
        </p>
        <img src={require('../images/inline-voeux.jpg')} />
      </>
    ),
    link: null
  },
  {
    id: 11,
    color: 'grey',
    title: 'Un billet d’humeur en 1920',
    description: "Journal de l'époque",
    image: 'humeur.jpg',
    html: (
      <>
        <h4>Un billet d’humeur en 1920</h4>
        <p>
          Interdites de fabrication, de transport, de vente, d’importation et
          d’exportation par un amendement à la Constitution américaine, les
          boissons alcoolisées ne sont plus tolérées aux États-Unis. La
          prohibition a officiellement commencé en 1920 mais un chroniqueur de
          «La Tribune de Genève» fustige ce mouvement hostile à l’alcool dans un
          billet paru le 19 octobre 1919. «On condamne les braves gens modérés à
          absorber des quantités énormes de thé qui leur détraquent le cœur ou
          des boissons glacées qui leur abîment l’estomac.» Et le journaliste de
          fustiger «les sectes exaltées et d’un mysticisme presque épileptique»
          qui professent aussi l’interdiction de l’usage du tabac. La statue de
          la Liberté a-t-elle encore un sens dans le port de New York? se
          demande-t-il.
        </p>
        <img src={require('../images/inline-humeur.jpg')} />
      </>
    ),
    link: null
  },
  {
    id: 12,
    color: 'yellow',
    title: "L'autre virus qui a ébranlé Genève",
    description: "Parole d'expert",
    image: 'expert-3.jpg',
    html: null,
    link: '620918796456'
  },
  {
    id: 13,
    color: 'yellow',
    title: 'La mort, grande absente des reportages de tranchées',
    description: "Parole d'expert",
    image: 'expert-4.jpg',
    html: null,
    link: '808269275305'
  },
  {
    id: 14,
    color: 'grey',
    title: null, // 'La Julie',
    description: null, // "Journal de l'époque",
    image: 'newspaper9.jpg',
    html: null /* (
      <>
        <h4>La Julie, le premier journal romand vendu un sou</h4>
        <p>
          Découvrir le premier exemplaire numérisé de la «Tribune de Genève»,
          datant du 1er février 1879, est une expérience à la fois touchante et
          surprenante. Saviez-vous, par exemple, que votre Julie était à
          l’origine un journal du soir, et ce jusqu’en 1990?
        </p>
        <p>
          Si elle a vu le jour, c’est grâce à un Américain, James T. Bates,
          ancien colonel de l’armée américaine. «En 1875, il achète le
          «Continental Herald and Swiss Times», destiné aux Britanniques établis
          dans la région genevoise. Il le rebaptise «Geneva Times» et développe
          l’information locale», raconte Philippe Amez-Droz, chercheur, chargé
          de cours au MediaLab à l’Université de Genève et membre du comité de
          l’Association pour la numérisation des journaux patrimoniaux genevois.
        </p>
        <p>
          En 1879, le journal abandonne l’anglais pour le français et devient
          «La Tribune de Genève». Le surnom de «Julie» donné au quotidien
          genevois apparaît rapidement après création du titre. En 1879, le
          leader radical Georges Favon, rédacteur en chef du «Genevois», était
          en effet tellement excédé par sa belle-sœur, prénommée Julie, qui
          préférait la «Tribune» à son propre journal, qu’il se mit d’abord à
          parler du «journal de Julie», puis de la «Julie» tout court. «Le terme
          «tribune» est, lui, inspiré par les quotidiens anglophones, comme le
          «New-York Daily Tribune», relève Philippe Amez-Droz.
        </p>
      </>
    ) */,
    link: null
  },
  {
    id: 15,
    color: 'grey',
    title: null, // 'La publicité en une',
    description: null, // "Journal de l'époque",
    image: 'newspaper4.jpg',
    html: null /* (
      <>
        <h4>La publicité en une</h4>
        <p>
          «La Tribune de Genève» devient en quinze ans le plus gros tirage
          romand, passant de 3000 exemplaires en 1879 à 20’000 exemplaires, puis
          le deuxième de toute la Suisse derrière le «Tages-Anzeiger». L’une des
          raisons de son succès populaire est son prix. Elle se vend 5 centimes
          au numéro à la criée, ce qui en fait le premier quotidien romand à un
          sou. Et il faut débourser 10 centimes la ligne ou son espace pour y
          insérer une petite annonce. «Le journal est une vitrine avant tout
          pour la publicité, note Philippe Amez-Droz.
        </p>
        <p>
          Le modèle économique de la presse du XIXe siècle repose sur un prix de
          vente au numéro très bas et une pagination comportant 50% ou plus de
          petites annonces ou autres annonces commerciales. Les encarts
          publicitaires, toujours plus nombreux, ont une telle importance qu’ils
          seront placés dès 1886 en une du journal. Certaines éditions
          comporteront même uniquement des annonces. Jusqu’à la Première Guerre
          mondiale, les seules illustrations sont des dessins pour animer les
          réclames.» Si, durant la première décennie, les publicités concernent
          surtout la santé et l’hygiène, la mode fera ensuite son apparition, et
          notamment la mode féminine.
        </p>
        <p>
          «L’intérêt de numériser la «Tribune de Genève» (ndlr: 12’274 éditions,
          soit 65’091 pages disponibles pour l’heure), c’est de disposer d’un
          matériau extraordinaire pour la recherche historique mais aussi
          sociologique, notamment en termes d’histoire du marketing, souligne
          Philippe Amez-Droz. On comprend mieux le positionnement des marques
          comme Maggi, qui perdurent au-delà du siècle, mais aussi la société et
          ses goûts. Longtemps, le succès de la presse quotidienne était le
          feuilleton. Un rituel aussi attendu qu’un nouvel épisode de notre
          série sur Netflix aujourd’hui.»
        </p>
        <p>
          Les quatre à six pages du journal sont alors très denses, rassemblant
          des brèves d’agences très factuelles, synthétisant l’actualité
          internationale et nationale, sans oublier les chroniques locales, un
          genre nouveau. Des papiers sans signature à l’époque.
        </p>
        <p>
          Dès la première édition, la ligne est claire: «Nous n’accepterons
          aucun mot d’ordre et, nous réservant toute notre indépendance, nous
          garderons notre liberté d’appréciation vis-à-vis de tous les partis.»
          Un choix éditorial qui fera des victimes, comme le résume Philippe
          Amez-Droz: «Cette presse d’information dite généraliste entraînera la
          mort de la presse politique.»
        </p>
      </>
    ) */,
    link: null
  },
  {
    id: 16,
    color: 'yellow',
    title: 'Ce fait divers qu’on adore détester',
    description: "Parole d'expert",
    image: 'expert-5.jpg',
    html: null,
    link: '433029081537'
  }
]
